import { DrawAction, DrawActionElement, DrawOptions } from '../draw-action';
import { FigureDrawAction } from './figure-draw-action';

declare const fabric;

export class TextDrawAction extends FigureDrawAction {

    drawActionElement: DrawActionElement = DrawActionElement.TEXT;

    createCanvasElement(options?: DrawOptions): any {

        let left = 10;
        let top = 10;
        let color = 'red';
        let borderWidth = 3;
        let textText = 'Text eingeben';
        let fontWeight = 100;

        if (options) {

            if (options.stampingPosition) {
                left = options.stampingPosition.x;
                top = options.stampingPosition.y;
            }

            if (options.color) {
                color = options.color.getColorString();
            }

            if (options.borderWidth) {
                borderWidth = options.borderWidth;
            }

            if (options.text) {
                textText = options.text;
            }

            switch (borderWidth) {
                case 1:
                case 2:
                    fontWeight = 100;
                    break;
                case 3:
                    fontWeight = 300;
                    break;
                case 5:
                    fontWeight = 500;
                    break;
                case 8:
                    fontWeight = 600;
                    break;
                case 10:
                    fontWeight = 700;
                    break;
                default:
                    fontWeight = 100;
            }

        }

        let cornerSize = DrawAction.defaults.cornerSize;

        if (this.isTouchDevice()) {
            cornerSize *= 2;
        }

        const text = new fabric.Text(textText, {
            fill: color,
            left,
            top,
            borderColor: DrawAction.defaults.borderColor,
            cornerColor: DrawAction.defaults.cornerColor,
            fontFamily: 'Open sans',
            fontWeight,
            cornerSize,
            transparentCorners: DrawAction.defaults.transparentCorners,
            fontSize: 20
        });

        return text;
    }
}
